import { ArrowUpRight, Star } from "@phosphor-icons/react";
import React from "react";

export const getStatusDetails = (status) => {
    const statusMap = {
        Pending_Guest: {
            title: "Pending On Guest",
            bgColor: "bg-[#FFF4D9]",
            headerBg: "bg-[#FFE29B]",
            statusBg: "bg-[#A88737]",
        },
        Pending_Hotel: {
            title: "Pending On You",
            bgColor: "bg-[#FFF2F2]",
            headerBg: "bg-[#FFBFC1]",
            statusBg: "bg-[#FF5A5F]",
        },
        InProgress_Hotel: {
            title: "Ongoing",
            bgColor: "bg-[#EEF0FB]",
            headerBg: "bg-[#939EDE]",
            statusBg: "bg-[#0B22B2]",
        },
        Scheduled_Hotel: {
            title: "Scheduled",
            bgColor: "bg-[#EDFFFA]",
            headerBg: "bg-[#D9F8F2]",
            statusBg: "bg-[#6DABA1]",
        },
    };
    return statusMap[status] || statusMap["Ongoing"];
};

export const statusOrder = [
    "Pending_Guest",
    "Pending_Hotel",
    "InProgress_Hotel",
    "Scheduled_Hotel",
];

export const getRelativeTime = (timestamp) => {
    const now = new Date();
    const updated = new Date(timestamp);
    const diffInSeconds = Math.floor((now - updated) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds}sec ago`;
    if (diffInSeconds < 3600)
        return `${Math.floor(diffInSeconds / 60)}min ago`;
    if (diffInSeconds < 86400)
        return `${Math.floor(diffInSeconds / 3600)}hr ago`;
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} ${days > 1 ? "days ago" : "day ago"}`;
};

export const serviceMap = {
    HouseKeeping: "Post-Checkin",
    "In Room Dining": "Post-Checkin",
    "PreCheckin Cab Request": "Pre-Checkin",
    "PostCheckin Cab Request": "Post-Checkin",
    Checkout: "Post-Checkin",
    "Conference Room": "Post-Checkin",
    "Custom Request": "Post-Checkin",
    "PreCheckin Early Checkin Request": "Pre-Checkin",
    "PostCheckin ExtendStay Request": "Post-Checkin",
    "PostCheckin Late Checkout Request": "Post-Checkin",
    "Restaurant Table": "Post-Checkin",
    "PostCheckin Room Change Request": "Post-Checkin",
    Spa: "Post-Checkin",
    "Wake Up Call": "Post-Checkin",
    "Web Checkin": "Pre-Checkin",
    "Get Wifi": "Post-Checkin",
};

export const activeComponentForType = (type) => {
    const componentMap = {
        "PreCheckin Cab Request": "ConfirmPrice",
        "PostCheckin Cab Request": "ConfirmPrice",
        "Web Checkin": "WebCheckin",
        "PreCheckin Early Checkin Request":
            "PreCheckin Early Checkin Request",
        "PostCheckin Late Checkout Request":
            "PostCheckin Late Checkout Request",
        "In Room Dining": "Dining",
        HouseKeeping: "HouseKeeping",
        "Wake Up Call": "WakeUp",
        "Conference Room": "Conference",
        "PostCheckin ExtendStay Request": "extendStay",
        "Custom Request": "Custom",
        "Restaurant Table": "Restaurant Table",
        "Get Wifi": "Get Wifi",
        Checkout: "Checkout",
        Spa: "Spa",
        "PostCheckin Room Change Request": "PostCheckin Room Change Request",
    };
    return componentMap[type] || "";
};

const RoomRequestsPanel = ({ requests, onOpenRequest }) => {
    const hasRequests = requests && requests.length > 0;

    // Group requests by status
    const groupedRequests = (requests || []).reduce((acc, request) => {
        const status = request.status.includes("Pending_Guest")
            ? "Pending_Guest"
            : request.status.includes("Pending_Hotel")
            ? "Pending_Hotel"
            : request.status.includes("InProgress_Hotel")
            ? "InProgress_Hotel"
            : "Scheduled_Hotel";
        if (!acc[status]) acc[status] = [];
        acc[status].push(request);
        return acc;
    }, {});

    return (
        <div className="w-[95%]">
            {!hasRequests ? (
                <div className="text-center p-4 bg-gray-200 rounded-md my-2">
                    No requests found.
                </div>
            ) : (
                statusOrder.map((status) => {
                    if (!groupedRequests[status]) return null;
                    const { title, bgColor, headerBg, statusBg } =
                        getStatusDetails(status);

                    return (
                        <div
                            key={status}
                            className={`${bgColor} rounded-md shadow-md overflow-hidden my-1`}
                        >
                            <div className={`${headerBg} p-2`}>
                                <h2
                                    className={`${statusBg} text-white rounded-full px-2 py-1 text-xs w-fit`}
                                >
                                    {title}
                                </h2>
                            </div>
                            <div className="p-2 flex flex-col gap-2 overflow-y-auto max-h-60">
                                <style jsx="true">{`
                                    div::-webkit-scrollbar {
                                        width: 6px;
                                        height: 8px;
                                    }
                                    div::-webkit-scrollbar-track {
                                        background: #d8d8d8;
                                        width: 10px;
                                    }
                                    div::-webkit-scrollbar-thumb {
                                        background-color: #888;
                                        border-radius: 10px;
                                    }
                                    div::-webkit-scrollbar-thumb:hover {
                                        background-color: #555;
                                    }
                                `}</style>
                                {groupedRequests[status]
                                    .sort(
                                        (a, b) =>
                                            new Date(b.updated_at) -
                                            new Date(a.updated_at),
                                    ) // Sorting by updated_at
                                    .map((request) => (
                                        <div
                                            key={request.id}
                                            className="bg-white rounded-md p-2 mb-2"
                                        >
                                            <div className="flex items-center justify-between border-b-[1.5px] pb-2">
                                                <h2 className="text-[#262B33]">
                                                    <span
                                                        className={`${
                                                            request.status ===
                                                            "InProgress_Hotel"
                                                                ? "text-[#0C196C]"
                                                                : "text-[#B74044]"
                                                        } mr-2 font-semibold`}
                                                    >
                                                        {request.type}
                                                    </span>
                                                </h2>
                                                <div className="relative inline-block">
                                                    <button
                                                        className=" border-[1.5px] rounded-md p-1.5 z-0 hover:bg-[#F2F7FF]"
                                                        onClick={() =>
                                                            onOpenRequest(request)
                                                        }
                                                    >
                                                        <ArrowUpRight
                                                            size={19}
                                                            weight="bold"
                                                        />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="flex items-center justify-between my-2">
                                                <button className="bg-[#F2F7FF] px-2 py-1 flex rounded-full items-center gap-1 text-xs">
                                                    <Star size={15} />
                                                    Assigned to{" "}
                                                    {
                                                        request.staff_member_name
                                                    }
                                                </button>
                                                <button
                                                    className={`${
                                                        request.type.split(
                                                            " ",
                                                        )[0] === "Pre"
                                                            ? "bg-[#FAE2E6] text-[#D02746]"
                                                            : "bg-[#ECE3FF] text-[#30214E]"
                                                    } px-2 py-1 flex rounded-full items-center gap-2 text-xs font-semibold`}
                                                >
                                                    <span
                                                        className={`w-1.5 h-1.5 ${
                                                            request.type.split(
                                                                " ",
                                                            )[0] === "Pre"
                                                                ? "bg-[#ff7378]"
                                                                : "bg-[#9983C6]"
                                                        } rounded-full`}
                                                    ></span>
                                                    {
                                                        serviceMap[
                                                            request.type
                                                        ]
                                                    }
                                                </button>
                                                <button
                                                    className="text-[#737880] text-xs text-nowrap"
                                                    // onClick={(e) => {
                                                    //     e.stopPropagation();

                                                    //     if (
                                                    //         serviceMap[
                                                    //             request.type
                                                    //         ] ===
                                                    //         "Pre-Checkin"
                                                    //     ) {
                                                    //         handleManageGuest(
                                                    //             request.booking_id,
                                                    //             request.booked_room_id,
                                                    //             e,
                                                    //         );
                                                    //     } else if (
                                                    //         request
                                                    //     ) {
                                                    //         handleManageRoom(
                                                    //             request.booking_id,
                                                    //             request.booked_room_id,
                                                    //             e,
                                                    //         );
                                                    //     }
                                                    // }}
                                                >
                                                    Booking#
                                                    <span
                                                        className="text-[#FF5A5F] font-semibold w-10 overflow-hidden truncate"
                                                        title={
                                                            request.booking_id
                                                        }
                                                    >
                                                        {request.booking_id.slice(
                                                            0,
                                                            6,
                                                        ) + ".."}
                                                    </span>
                                                </button>
                                                <button className="text-xs">
                                                    <span className="text-[#737880]">
                                                        Last updated
                                                    </span>{" "}
                                                    {getRelativeTime(
                                                        request.updated_at,
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default RoomRequestsPanel;
